import React, {useState, ReactNode} from 'react';
import {
  GestureResponderEvent, StyleProp, ViewStyle, TouchableOpacity, TextStyle, ColorValue, ActivityIndicator,
  LayoutChangeEvent
} from 'react-native';
import MainStyle from '../../MainStyle';
import {Fontisto} from '@expo/vector-icons';
import Div from "../lib/Div";
import P from "../lib/P";

type Props = {
  text: string, onPress?: ((event: GestureResponderEvent) => void), style?: StyleProp<ViewStyle>,
  w?: ViewStyle['width'], textStyle?: StyleProp<TextStyle>, h?: ViewStyle['height'], radius?: number, bg?: ColorValue,
  borderWidth?: number, borderColor?: ColorValue, fontSize?: number, mb?: ViewStyle['marginBottom'],
  ml?: ViewStyle['marginLeft'], mt?: ViewStyle['marginTop'], cardType?: string, color?: ColorValue, isLoading?: boolean,
  mx?: ViewStyle['marginHorizontal'], my?: ViewStyle['marginVertical'], shadow?: boolean, autoPlayIcon?: ReactNode,
  disabled?: boolean, flex?: number, fontWeight?: '400' | '500' | '600' | '700', maxH?: ViewStyle['maxHeight'],
  fontFamily?: 'Barlow-Regular' | 'Barlow-Medium' | 'Barlow-SemiBold' | 'Barlow-Bold' | 'Alternox-Regular' | 'Alternox-SemiBold' | 'Alternox-Bold' | 'DavisSans-Regular' | 'DavisSans-Medium' | 'StratosBoldItalic'
};

const Button = (props: Props) => {
  const {text, style, textStyle, w, h, radius, bg, borderWidth, mb, borderColor, fontSize, ml, mt, maxH} = props;
  const {cardType, color, isLoading, mx, my, shadow, autoPlayIcon, disabled, flex, fontWeight, fontFamily} = props;
  let btnStyle: StyleProp<ViewStyle> = [
    MainStyle.h_63, MainStyle.bg_newGreen, MainStyle.b_r_70, MainStyle.flex, MainStyle.j_c_c, MainStyle.a_i_c,
    MainStyle.row
  ];
  const [currBtnHeight, setCurrBtnHeight] = useState(40);
  let FontFamily = fontWeight === '400' ? 'Barlow-Regular' : fontWeight === '600' ? 'Barlow-SemiBold' : fontWeight === '700' ? 'Barlow-Bold' : 'Barlow-Medium';
  if (fontFamily) FontFamily = fontFamily;

  if (Array.isArray(style)) btnStyle = [...btnStyle, ...style];
  else if (style) btnStyle.push(style);

  if (w !== undefined) btnStyle.push({width: w});
  if (h !== undefined) btnStyle.push({height: h});
  if (maxH !== undefined) btnStyle.push({maxHeight: maxH});
  if (radius !== undefined) btnStyle.push({borderRadius: radius});
  if (bg) btnStyle.push({backgroundColor: bg});
  if (borderWidth !== undefined) btnStyle.push({borderWidth});
  if (borderColor) btnStyle.push({borderColor});
  if (mb !== undefined) btnStyle.push({marginBottom: mb});
  if (ml !== undefined) btnStyle.push({marginLeft: ml});
  if (mt !== undefined) btnStyle.push({marginTop: mt});
  if (mx !== undefined) btnStyle.push({marginHorizontal: mx});
  if (my !== undefined) btnStyle.push({marginVertical: my});
  if (flex !== undefined) btnStyle.push({flex});
  if (shadow) {
    btnStyle.push({
      shadowOffset: {width: 0, height: 4},
      shadowRadius: 4,
      shadowColor: "rgba(0, 0, 0, 0.25)",
      shadowOpacity: 1
    })
  }

  const onLayout = (event: LayoutChangeEvent) => {
    const {height} = event.nativeEvent.layout;
    setCurrBtnHeight(height);
  };

  return (
    <TouchableOpacity onPress={props.onPress} style={[...btnStyle, disabled && MainStyle.o_05]} onLayout={onLayout}
                      disabled={isLoading || disabled}>
      {cardType && (
        <Div mr={10}>
          <Fontisto name={cardType as 'visa' | 'mastercard' | 'american-express'} size={18} color="white"/>
        </Div>
      )}

      {autoPlayIcon}

      {isLoading ? (
        <ActivityIndicator color="white" size={currBtnHeight * 0.6}/>
      ) : (
        <P fontFamily={FontFamily as any} fs={fontSize || 22} ta="center" color={color || 'black'} style={textStyle}>
          {text}
        </P>
      )}
    </TouchableOpacity>
  );
};

export default React.memo(Button);
